import { ExternalLink } from "lucide-react";
import { type AnchorHTMLAttributes, forwardRef } from "react";
import { cn } from "../lib/cn";

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
	external?: boolean;
}

const Link = forwardRef<HTMLAnchorElement, LinkProps>(
	({ className, external = false, children, ...props }, ref) => (
		<a
			ref={ref}
			className={cn(
				"text-primary underline-offset-4 hover:underline inline-flex items-center gap-1",
				className,
			)}
			{...(external ? { rel: "noopener noreferrer", target: "_blank" } : {})}
			{...props}
		>
			{children}
			{external && (
				<ExternalLink className="h-3 w-3 shrink-0" aria-hidden="true" />
			)}
		</a>
	),
);
Link.displayName = "Link";

export default Link;
export { Link };
